import EstimateProvider from "@/providers/estimate.provider";
import type { EstimationSliceI, LineItemXactimateMapping, SelectedLineItem } from "../slices/estimation.slice";
import { setEstimationStateAction, addToSelection, removeFromSelection, toggleSelection, clearSelection } from "../slices/estimation.slice";
import type { AppDispatch, RootState } from "../store";
import { normalizeLineItemToLowerCase } from "@/components/estimation-details/xactimate/utils/xactimate";

const setEstimationState = (data: EstimationSliceI) => {
  return (dispatch: AppDispatch) => {
    dispatch(
      setEstimationStateAction({
        ...data,
      }),
    );
  };
};

const addLineItemToSelection = (item: SelectedLineItem) => {
  return (dispatch: AppDispatch) => {
    dispatch(addToSelection(item));
  };
};

const removeLineItemFromSelection = (item: SelectedLineItem) => {
  return (dispatch: AppDispatch) => {
    dispatch(removeFromSelection(item));
  };
};

const toggleLineItemSelection = (item: SelectedLineItem, isShiftClick: boolean = false) => {
  return (dispatch: AppDispatch) => {
    dispatch(toggleSelection({ item, isShiftClick }));
  };
};

const clearLineItemSelection = () => {
  return (dispatch: AppDispatch) => {
    dispatch(clearSelection());
  };
};

const updateXactimateMappingForLineItem = (lineItem: string, lineItemId: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      const { data } = await EstimateProvider.getXactimateMappingForLineItem(lineItem, lineItemId);
      const currentMappings = getState().estimation.lineItemXactimateMapping || [];

      const mappingData =
        data && Object.keys(data).length > 0
          ? (Object.values(data)[0] as {
              cat?: string;
              sel?: string;
              activity?: string;
              quantity?: string;
            })
          : {};

      // Replace only the mapping for this exact (lineItemId, lineItem) pair so other rows
      // sharing the same catalog lineItemId keep their entries.
      const normalizedLineItem = normalizeLineItemToLowerCase(lineItem);
      const updatedMappings = currentMappings.filter((mapping: LineItemXactimateMapping) => {
        const sameId = mapping.lineItemId === lineItemId;
        const sameText = normalizeLineItemToLowerCase(mapping.lineItem) === normalizedLineItem;
        return !(sameId && sameText);
      });
      updatedMappings.push({
        lineItemId,
        lineItem,
        cat: mappingData.cat,
        sel: mappingData.sel,
        activity: mappingData.activity,
        quantity: mappingData.quantity,
      });

      dispatch(
        setEstimationStateAction({
          lineItemXactimateMapping: updatedMappings,
        }),
      );
    } catch (error) {
      console.error("Failed to update Xactimate mapping for line item:", error);
    }
  };
};

export const estimationActions = {
  setEstimationState,
  addLineItemToSelection,
  removeLineItemFromSelection,
  toggleLineItemSelection,
  clearLineItemSelection,
  updateXactimateMappingForLineItem,
};
